import { Capacitor } from '@capacitor/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';

//Log in to web session
export async function syncLoginToWeb(ajaxUrl, accessToken, lang = 'fi') {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
  
    if (!ajaxUrl || !accessToken) {
      console.warn('ajaxUrl or accessToken missing');
      return;
    }
  
    try {
      const loginUrl = `${ajaxUrl}?action=inappbrowser&access_token=${encodeURIComponent(accessToken)}&lang=${lang}`;
      const options = 'location=no,hidden=yes,clearcache=no';
  
      const browserRef = InAppBrowser.create(loginUrl, '_blank', options);
  
      browserRef.on('loadstop').subscribe((event) => {
        if (event.url.includes('action=inappbrowser')) {
          browserRef.close();
        }
      });
  
    } catch (error) {
      console.error('[syncLoginToWeb] Error in InAppBrowser:', error);
    }
}

export async function syncLogoutFromWeb(ajaxUrl) {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    const logoutUrl = `${ajaxUrl}?action=logout&applogout=1`;
    const options = 'location=no,hidden=yes';
    const browserRef = InAppBrowser.create(logoutUrl, '_blank', options);

    browserRef.on('loadstop').subscribe((event) => {
      if (event.url.includes('?action=logout')) {
        browserRef.close();
      }
    });
  } catch (error) {
    console.error('[syncLogoutFromWeb] Error in InAppBrowser:', error);
  }
}